// extracted by mini-css-extract-plugin
export default {"main":"Header_main__pkzLd","container":"Header_container__X4ynk","navigation":"Header_navigation__O6iao","active":"Header_active__Gin8B"};